<template>
  <div class="right-home product-list" ref="bookListWrapper">
    <div class="breadcrumb" v-if="!storeProd">产品列表</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <!-- <el-row> -->
          <el-col :span="6">
            <el-form-item label="产品名称:">
              <el-input v-model="formInline.spuName" placeholder="请输入产品名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品性质:">
              <el-select v-model="formInline.spuProperty" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option v-for="item in natureList" :key="item.id" :label="item.dictValue" :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品分类:" v-permission="'pms:admin:category:list'">
              <el-cascader :show-all-levels="false" placeholder="请选择" clearable v-model="formInline.categoryId" :props="props">
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-permission="'pms:admin:sale:false'">
            <el-form-item label="上架状态:">
              <el-select v-model="formInline.onSale" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option label="已上架" :value="1"></el-option>
                <el-option label="已下架" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- </el-row> -->
          <el-col :span="5">
            <el-form-item label="产品属性:">
              <el-select v-model="formInline.isSeries" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option label="普通产品" value="0"></el-option>
                <el-option label="套系产品" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="!storeProd">
            <el-form-item label="是否参与折扣包:" label-width="150px">
              <el-select v-model="formInline.discountBundle" placeholder="请选择" clearable>
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, onSubmit()" round>查询</el-button>
            <el-button class="search-ok" @click="createProduct('创建普通产品')" round type="primary" v-permission="'pms:admin:spu:add'" style="min-width: auto !important;" v-if="!storeProd"> 创建普通产品
            </el-button>
            <el-button class="search-ok" @click="createProduct('创建套系产品')" round type="primary" v-permission="'pms:admin:spu:add'" style="min-width: auto !important;" v-if="!storeProd"> 创建套系产品
            </el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column label="产品ID" prop="id" min-width="10px">
          </el-table-column>
          <el-table-column prop="spuName" label="产品名称" min-width="10px">
          </el-table-column>
          <el-table-column label="产品主图" min-width="10">
            <template v-slot="scope">
              <img :src="scope.row.spuImage" alt="">
            </template>
          </el-table-column>
          <el-table-column prop="propertyName" label="产品性质" min-width="10">
            <template slot-scope="scope"> {{ scope.row.spuProperty === 'NORMAL' ? '通货' : scope.row.spuProperty === 'CUSTOM' ? '定制' : '未定义' }} </template>
          </el-table-column>
          <el-table-column prop="propertyName" label="产品属性" min-width="10">
            <template slot-scope="scope"> {{ scope.row.isSeries ? '套系产品' : '普通产品' }} </template>
          </el-table-column>
          <el-table-column prop="propertyName" label="产品状态" min-width="10">
            <template slot-scope="scope"> {{ scope.row.isHidden ? '隐藏' : '显示' }} </template>
          </el-table-column>
          <el-table-column prop="cate" label="产品分类" min-width="10">
          </el-table-column>
          <el-table-column label="单独推送平台数量" min-width="10">
            <template slot-scope="scope">
              <span v-if="('pms:admin:store:list')" @click="$router.push({ path: '/pushstore', query: { id: scope.row.id } })" class="color-blue">{{ scope.row.pushCounter }}</span>
              <span v-else>{{ scope.row.pushCounter }}</span>
            </template>
          </el-table-column>
          <el-table-column label="上架状态" min-width="10">
            <template slot-scope="scope"> {{ scope.row.onSale ? '已上架' : '已下架' }} </template>
          </el-table-column>
          <el-table-column label="是否参与折扣包" min-width="10">
            <template slot-scope="scope"> {{ scope.row.discountBundle ? '是' : '否' }} </template>
          </el-table-column>
          <el-table-column label="操作" min-width="10px" v-if="!storeProd">
            <template v-slot="scope">
              <span @click="checkItem('查看/编辑产品', scope.row)" class="color-blue">查看/编辑产品<br></span>
              <span @click="checkItem('查看SKU组', scope.row)" class="color-blue">查看SKU组<br></span>
              <span @click="checkItem('添加SKU组', scope.row)" v-if="$hasPermission('pms:admin:proList:addSku')" class="color-blue">添加SKU组<br></span>
              <div @click="deleteDialog = true, deleteSpuId = scope.row.id" v-if="!scope.row.onSale && $hasPermission('pms:admin:spu:delete')" class="color-blue" style="width: 100%;">删除</div>
              <div @click="copyDialog = true, copySpuId = scope.row.id" v-if="!scope.row.isSeries && $hasPermission('pms:admin:spu:copy')" class="color-blue" style="width: 100%;">复制</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    </div>
    <!-- 确认删除 -->
    <el-dialog :close-on-click-modal="false" title="确认提示" :visible.sync="deleteDialog" width="30%">
      <span>是否确认删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteSpu">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 确认复制 -->
    <el-dialog :close-on-click-modal="false" title="确认提示" :visible.sync="copyDialog" width="30%">
      <span>是否确认复制</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="copyDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitCopy">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import imgSrc from '@/assets/images/code.svg'
import store from '@/store'
import { spuList, categoryGet, categoryList, queryAllSubs, spuProperty, categoryQuerySub, spuDelete, copySpu } from '@/api/pms'
export default {
  name: 'product-list',
  components: {
    VPagination
  },
  props: {
    // 折扣包管理中查看折扣产品的时候用到的
    storeProd: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      id: 0,
      props: !this.$hasPermission('pms:admin:category:list') ? {} : {
        checkStrictly: true,
        emitPath: false,
        lazy: true,
        lazyLoad (node, resolve) {
          const { level, value } = node
          if (level === 0) {
            categoryList(value).then(res => {
              let nodes = res.data.data.map(item => {
                return {
                  value: item.id,
                  label: item.categoryName,
                  leaf: item.bottom || item.id === 4
                }
              })
              resolve(nodes)
            })
          } else if (level === 1) {
            queryAllSubs(value).then(res => {
              let nodes = res.data.data.subCategoryList.map(item => {
                return {
                  value: item.id,
                  label: item.categoryName,
                  leaf: item.subCategoryList.length === 0,
                  subCategoryList: item.subCategoryList
                }
              })
              resolve(nodes)
            })
          } else {
            let nodes = node.data.subCategoryList.map(item => {
              return {
                value: item.id,
                label: item.categoryName,
                leaf: item.subCategoryList.length === 0,
                subCategoryList: item.subCategoryList
              }
            })
            resolve(nodes)
          }
        }
      },
      deleteSpuId: '',
      copySpuId: '',
      deleteDialog: false,
      copyDialog: false,
      natureList: [],
      treeData: '',
      treeDataValue: '',
      formInline: {
        discountBundle: this.storeProd ? 1 : '',
        isSeries: '',
        categoryId: '',
        onSale: '',
        spuName: '',
        spuProperty: ''
      },
      tableData: [],
      defaultProps: {
        // children: 'children',
        label: 'name'
      },
      queryInfo: {
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      rememberScroll: null
    }
  },
  // beforeRouteEnter (to, from, next) {
  //   next(vm => {
  //     console.log('进入了这里')
  //     vm.getProList(vm.queryInfo)
  //   })
  // },
  mounted () {
    // console.log('mounted')
    this.$refs.bookListWrapper.addEventListener('scroll', this.handleScroll)
    // 根据本地缓存取出初始值并渲染页面
    this.rememberScroll = sessionStorage.getItem('offsetY')
    this.$refs.bookListWrapper.scrollTo(0, this.rememberScroll)
  },
  // 实例销毁之前调用
  beforeDestroy () {
    // console.log('页面销毁beforeDestroy')
    if (this.rememberScroll) {
      sessionStorage.setItem('offsetY', this.rememberScroll)
    } else {
      sessionStorage.setItem('offsetY', 0)
    }
  },
  destroyed () {
    // 销毁
    // console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  async created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
      sessionStorage.removeItem('offsetY')
    }
    if (this.$notPerm('pms:admin:sale:false')) {
      this.formInline.onSale = 1
    }
    if (this.$hasPermission('pms:admin:property:list')) {
      // 获取产品性质
      await this.getProNature()
    }
    await this.getProList(this.queryInfo)
    // // 判断页面当前停留位置
    this.$nextTick(() => {
      if (sessionStorage.getItem('offsetY')) {
        this.$refs.bookListWrapper.addEventListener('scroll', this.handleScroll)
        // 根据本地缓存取出初始值并渲染页面
        this.rememberScroll = sessionStorage.getItem('offsetY')
        this.$refs.bookListWrapper.scrollTo(0, this.rememberScroll)
      }
    })
  },
  methods: {
    handleScroll (e) { // vue 方法中可直接加e获取event，当@click方法不加括号默认传event参数。
      const target = e.target // 获取元素目标
      if (target) {
        this.rememberScroll = target.scrollTop// 获取离页面上方高度
        // console.log(this.rememberScroll)
      } else {
        this.rememberScroll = 0
      }
    },
    // 删除产品
    deleteSpu () {
      spuDelete(this.deleteSpuId).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.getProList(this.queryInfo)
          this.deleteDialog = false
        }
      })
    },
    // 确认复制
    submitCopy () {
      copySpu(this.copySpuId).then(res => {
        if (res.data.success) {
          this.$message.success('复制成功')
          this.getProList(this.queryInfo)
          this.copyDialog = false
        }
      })
    },
    // 设置cookie
    setCookie () {
      // 获取当前路由，将当前页面的路由作为name存入cookie中
      let name = this.$route.path
      // 需要存入的参数
      document.cookie = name + '=' + this.$qs.stringify(this.formInline)
    },
    onSubmit () {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      }
      this.getProList(this.queryInfo)
    },
    async getProNature () {
      // 获取产品性质
      await spuProperty().then((res) => {
        this.natureList = res.data.data
      })
    },
    aaaa (item, str, list) {
      if (item.subCategory !== undefined) {
        str = '>' + item.categoryName + str
        return this.aaaa(item.subCategory, str, list)
      } else {
        str = item.categoryName + str
        list.ownCategoryId = item.id
        return str
      }
    },
    async getProList (val) {
      await spuList({ pageNum: val.pageNum, pageSize: val.pageSize, spuVO: this.formInline }).then((res) => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.getProList(this.queryInfo)
          }
          let list = res.data.data.records
          list.forEach((item, index) => {
            item.cate = this.aaaa(item.category, '', item)
          })
          this.tableData = list
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    checkItem (val, content) {
      if (this.rememberScroll) {
        sessionStorage.setItem('offsetY', this.rememberScroll)
      } else {
        sessionStorage.setItem('offsetY', 0)
      }
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      this.setCookie()
      if (val === '查看/编辑产品') {
        console.log(content.id)
        this.$router.push({
          path: this.$hasPermission('pms:admin:spu:update') ? '/editpro' : '/CheckProductDetail',
          query: {
            id: content.id,
            isSeries: content.isSeries,
            propertyName: content.spuProperty === 'NORMAL' ? '通货' : '定制'
          }
        })
      }
      // let startupsSpu = content.startupsSpu
      let startupsSpu = false
      if (content.topCategoryId == 10) {
        startupsSpu = true
      } else {
        startupsSpu = false
      }
      let showPoint = false
      if (content.topCategoryId == 13) {
        showPoint = true
      }
      if (val === '添加SKU组') {
        if (content.isSeries) {
          this.$router.push({
            path: './createsyssku',
            query: {
              spuId: content.id,
              spuProperty: content.spuProperty,
              categoryId: content.topCategoryId,
              startupsSpu: startupsSpu,
              showPoint
            }
          })
        } else {
          this.$router.push({
            path: './createsku',
            query: {
              id: content.id,
              spuProperty: content.spuProperty,
              spuName: content.spuName,
              categoryId: content.topCategoryId,
              startupsSpu: startupsSpu,
              showPoint
            }
          })
        }
      }
      if (val === '查看SKU组') {
        this.$router.push({
          path: './viewsku',
          query: {
            id: content.id,
            ownCategoryId: content.ownCategoryId,
            startupsSpu: startupsSpu,
            spuType: content.spuType,
            showPoint
          }
        })
      }
    },
    createProduct (val) {
      if (this.rememberScroll) {
        sessionStorage.setItem('offsetY', this.rememberScroll)
      } else {
        sessionStorage.setItem('offsetY', 0)
      }
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      if (val === '创建普通产品') {
        this.$router.push({
          path: './createPro',
          query: {
            id: 0
          }
        })
      }
      if (val === '创建套系产品') {
        this.$router.push({
          path: './createPro',
          query: {
            id: 1
          }
        })
      }
    },
    clearHandle () {
    },
    handNodeClick (data, node, nodeData) {
      if (node.childNodes.length === 0) {
        this.treeDataValue = data
        this.formInline.categoryId = data.name
        this.$refs.multiSelect.blur()
      }
    },
    changePage (val) {
      this.queryInfo = val
      this.getProList(this.queryInfo)
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";

@{deep} .el-cascader {
  line-height: 30px;
}
</style>
